<div class="c-loading" *ngIf="displayModal">
  <div class="c-loading-item">
    <i class="fa fa-spinner fa-spin"></i>

    <div class="c-loading-label">{{mensagem}}</div>
  </div>
</div>
